import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import ContainerLayout from "container-layout";
import ReactGA from "react-ga4";
import { END_POINTS } from "constants/APIConstant";

function App() {

  ReactGA.initialize(END_POINTS.TRACKING_ID)
  
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
          <ContainerLayout />
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
